
import { Component, OnInit, Inject } from '@angular/core';
import { identifierModuleUrl } from '@angular/compiler';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DgHubClientService, SettingsRequest, Settings } from 'src/app/Services/dg-hub-client.service';
import { DrawingService } from 'src/app/Services/DrawingService';

@Component({
  selector: 'app-settings-dialog',
  templateUrl: './settings-dialog.component.html',
  styleUrls: ['./settings-dialog.component.css']
})
export class SettingsDialogComponent implements OnInit {


  constructor(
    public dialogRef: MatDialogRef<SettingsDialogComponent>,
    private fb: FormBuilder,
    public dgCLientService:DgHubClientService,
    public drawingService:DrawingService
    ) {

  }

  settingsForm = this.fb.group({
    numberOfWaves: [null],
    totalNumberOfWaves: [null],
    pernamentLineHeight: [null],
    intermediateLineHeight: [null],
    pernamentLineWidth:[null],
    numberOfWavesOverlay: [null],
    totalNumberOfWavesOverlay: [null],
    pernamentLineHeightOverlay: [null],
    intermediateLineHeightOverlay: [null],
    pernamentLineWidthOverlay:[null],
    smaGreyLineMin:[null],
    smaPurpleLineMin:[null]
  })

  ngOnInit() {

    this.settingsForm.controls["numberOfWaves"].setValue(this.drawingService.numberOfWaves);
    this.settingsForm.controls["totalNumberOfWaves"].setValue(this.drawingService.totalNumberOfWaves);
    this.settingsForm.controls["pernamentLineHeight"].setValue(this.drawingService.pernamentLineHeight);
    this.settingsForm.controls["intermediateLineHeight"].setValue(this.drawingService.intermediateLineHeight);
    this.settingsForm.controls["pernamentLineWidth"].setValue(this.drawingService.pernamentLineWidth);

    this.settingsForm.controls["numberOfWavesOverlay"].setValue(this.drawingService.overlayConfig.numberOfWaves);
    this.settingsForm.controls["totalNumberOfWavesOverlay"].setValue(this.drawingService.overlayConfig.totalNumberOfWaves);
    this.settingsForm.controls["pernamentLineHeightOverlay"].setValue(this.drawingService.overlayConfig.pernamentLineHeight);
    this.settingsForm.controls["pernamentLineWidthOverlay"].setValue(this.drawingService.overlayConfig.pernamentLineWidth);
    this.settingsForm.controls["intermediateLineHeightOverlay"].setValue(this.drawingService.overlayConfig.intermediateLineHeight);

    this.settingsForm.controls["smaGreyLineMin"].setValue(this.drawingService.smaDifBackground);
    this.settingsForm.controls["smaPurpleLineMin"].setValue(this.drawingService.smaDifForeground);

  }

  onConfirm(): void {
    // Close the dialog, return true

     var settings:Settings = {
      numberOfWaves: Number(this.settingsForm.controls["numberOfWaves"].value),
      totalNumberOfWaves: Number(this.settingsForm.controls["totalNumberOfWaves"].value),
      pernamentLineHeight:Number(this.settingsForm.controls["pernamentLineHeight"].value),
      intermediateLineHeight:Number(this.settingsForm.controls["intermediateLineHeight"].value),
      pernamentLineWidth:Number(this.settingsForm.controls["pernamentLineWidth"].value),
      smaDiff:Number(this.settingsForm.controls["smaPurpleLineMin"].value),
      name:"Main"
    }

    var settingsOverlay:Settings = {
      numberOfWaves: Number(this.settingsForm.controls["numberOfWavesOverlay"].value),
      totalNumberOfWaves: Number(this.settingsForm.controls["totalNumberOfWavesOverlay"].value),
      pernamentLineHeight:Number(this.settingsForm.controls["pernamentLineHeightOverlay"].value),
      intermediateLineHeight:Number(this.settingsForm.controls["intermediateLineHeightOverlay"].value),
      pernamentLineWidth:Number(this.settingsForm.controls["pernamentLineWidthOverlay"].value),
      smaDiff:Number(this.settingsForm.controls["smaGreyLineMin"].value),
      name:"Overlay"
    }

    var request:SettingsRequest = {
      numberOfWaves: Number(this.settingsForm.controls["numberOfWaves"].value),
      totalNumberOfWaves: Number(this.settingsForm.controls["totalNumberOfWaves"].value),
      pernamentLineHeight:Number(this.settingsForm.controls["pernamentLineHeight"].value),
      intermediateLineHeight:Number(this.settingsForm.controls["intermediateLineHeight"].value),
      pernamentLineWidth:Number(this.settingsForm.controls["pernamentLineWidth"].value),
      settings:[settings, settingsOverlay],
      viewName: this.drawingService.selectedViewName
    }

    this.dgCLientService.ChangeSettings(request);
    this.drawingService.smaDifBackground = Number(this.settingsForm.controls["smaGreyLineMin"].value);
    this.drawingService.smaDifForeground = Number(this.settingsForm.controls["smaPurpleLineMin"].value);
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false


    this.dialogRef.close(false);
  }
}
